import styled from 'styled-components';

import { variableFontRegular, variableFontMedium } from 'styles/theme/text';
import {
  FAQ_Q_HOW,
  FAQ_A_HOW,
  FAQ_TRANSACTION,
  FAQ_STATEMENT_CODE,
  FAQ_A_HOW_EXPAND,
  FAQ_Q_WHY,
  FAQ_A_WHY,
  FAQ_Q_WHAT,
  FAQ_A_WHAT,
} from 'paymentVerifications/enums/paymentVerificationsFaqEnums';
import { getTranslations } from 'shared/utils/getTranslations';

interface IFaqProps {
  className?: string;
}

export default function FAQ({ className }: IFaqProps): JSX.Element {
  const [faqQhow, faqAhow, faqAHowExpand, faqQWhy, faqAWhy, faqQwhat, faqAWhat] = getTranslations([
    FAQ_Q_HOW,
    FAQ_A_HOW,
    FAQ_A_HOW_EXPAND,
    FAQ_Q_WHY,
    FAQ_A_WHY,
    FAQ_Q_WHAT,
    FAQ_A_WHAT,
  ]);
  return (
    <FAQ.Content className={className} data-qa="faq_wrapper">
      <FAQ.Heading data-qa="faq_question">
        <span>{faqQhow}</span>
      </FAQ.Heading>
      <FAQ.Paragraph>{faqAhow}</FAQ.Paragraph>
      <pre>
        {FAQ_TRANSACTION}
        <FAQ.Mark>{FAQ_STATEMENT_CODE}</FAQ.Mark>
      </pre>
      <FAQ.Paragraph>{faqAHowExpand} </FAQ.Paragraph>
      <FAQ.Heading data-qa="faq_question">
        <span>{faqQWhy}</span>
      </FAQ.Heading>
      <FAQ.Paragraph>{faqAWhy}</FAQ.Paragraph>
      <FAQ.Heading data-qa="faq_question">{faqQwhat}</FAQ.Heading>
      <FAQ.Paragraph>
        <span>{faqAWhat}</span>
      </FAQ.Paragraph>
    </FAQ.Content>
  );
}

FAQ.Content = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.primary};
  padding: 24px;
`;
FAQ.Heading = styled.h1`
  ${variableFontMedium({ size: '16px' })}
  &:first-child {
    margin-top: 0;
  }
`;
FAQ.Paragraph = styled.p`
  ${variableFontRegular({ size: '11.5px' })}
  &:last-child {
    margin-bottom: 0;
  }
`;
FAQ.Mark = styled.mark`
  background-color: yellow;
`;
